import { render, staticRenderFns } from "./lock.vue?vue&type=template&id=4d07c773&scoped=true"
import script from "./lock.vue?vue&type=script&lang=js"
export * from "./lock.vue?vue&type=script&lang=js"
import style0 from "./lock.vue?vue&type=style&index=0&id=4d07c773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d07c773",
  null
  
)

export default component.exports